import React from 'react';
import CardInfo from './CardBaseTransport';
import { useLang } from '../i18n';
import './Cards.css';

function Transport() {
  const { t } = useLang();
  return (
    <div>
      <div className='cards__next'>
        <h1>{t('info.transportTitle')}</h1>
        <div className='cards__container'>
          <div className='cards__wrapper'>
            <ul className='cards__items'>
              <CardInfo 
                text1={t('info.transportIntro')}
                label1={t('info.transportBa')}
                label2={t('info.transportVie')}
                text2={t('info.transportDetails')}
                text3={t('info.transportWalking')}
              />
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Transport;